/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MessageLevelEnum } from './messageLevelEnum';
import { MessageTypeEnum } from './messageTypeEnum';
import { MessageDeliveryError } from './messageDeliveryError';
import { Message } from './message';
import { MessageReplyTo } from './messageReplyTo';
import { NotificationResourceAction } from './notificationResourceAction';
import { MessageStateEnum } from './messageStateEnum';
import { MessageRecipient } from './messageRecipient';
import { RequestOriginEnum } from './requestOriginEnum';


export interface NotificationMessageDetailedResponse { 
    /**
     * Created Date Time
     */
    created_date_time?: Date;
    /**
     * Errors
     */
    errors?: Array<MessageDeliveryError>;
    /**
     * Time after which the notification should expire. This could be time in seconds, minutes, hours and days.
     */
    expires_in?: string;
    /**
     * Last Updated Date Time
     */
    last_updated_date_time?: Date;
    level?: MessageLevelEnum;
    message_id?: string;
    origin?: RequestOriginEnum;
    resource_action?: NotificationResourceAction;
    resource_id?: string;
    /**
     * Number of attempts made to deliver the message notification.
     */
    retry_attempts?: number;
    /**
     * Service type for the message
     */
    service_type?: string;
    state?: MessageStateEnum;
    /**
     * Number of attempts failed to get the message notification delivery status.
     */
    status_check_attempts?: number;
    /**
     * User who initiated the notification request directly or indirectly.
     */
    triggered_by?: string;
    type?: MessageTypeEnum;
    /**
     * Email id for \'from\'. Default value \'donotreply@vmware.com\'.
     */
    from?: string;
    message?: Message;
    recipient?: MessageRecipient;
    reply_to?: MessageReplyTo;
}
export namespace NotificationMessageDetailedResponse {
}


